import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials, type Testimonial } from '../data/testimonials';
import { SectionLabel } from './ui/SectionLabel';
export function TestimonialsSection() {
  const [featured, ...rest] = testimonials;
  return <section className="w-full bg-sand py-10 sm:py-14 lg:py-20" aria-labelledby="testimonials-heading" data-id="element-217" data-mp="1mxxzbef6l0ob">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-218" data-mp="1d1uqjpptq3se">
        <div className="mx-auto max-w-2xl text-center" data-id="element-219" data-mp="1d0jktkctilyn">
          <div className="flex justify-center" data-id="element-220" data-mp="1i17k0tb7a93y">
            <SectionLabel data-id="element-221" data-mp="1hyuvfxaxt0hx">From teachers</SectionLabel>
          </div>
          <h2 id="testimonials-heading" className="mt-3 font-serif text-[1.5rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-222" data-mp="142hmxdods9fl">
            Why teachers love having a
            <span className="block text-forest" data-id="element-223" data-mp="2yfz2ademtzzj">Ready-to-Teach library</span>
          </h2>
        </div>

        <div className="mt-6 sm:hidden" data-id="element-224" data-mp="32fzponjplliq">
          <TestimonialCard testimonial={featured} featured data-id="element-225" data-mp="2v12m70yt8jb6" />
          <ul className="-mx-5 mt-3 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2" aria-label="More teacher reviews" data-id="element-226" data-mp="2uzhs1cger2du">
            {rest.map(testimonial => <li key={testimonial.name} className="w-[80%] shrink-0 snap-start" data-id="element-227" data-mp="34t8bg2xogmmo">
                <TestimonialCard testimonial={testimonial} data-id="element-228" data-mp="2zt2q14i03wd1" />
              </li>)}
          </ul>
          <p className="mt-1 text-center text-[0.55rem] uppercase tracking-label text-muted" data-id="element-229" data-mp="2c4t29x188yj9">
            Swipe for more
          </p>
        </div>

        <div className="mt-8 hidden gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3" data-id="element-230" data-mp="2m1627cnd88mg">
          <div className="sm:col-span-2 lg:col-span-1 lg:row-span-2" data-id="element-231" data-mp="2h19zrhubgp90">
            <TestimonialCard testimonial={featured} featured data-id="element-232" data-mp="2h45yv9hwhjz1" />
          </div>
          {rest.map(testimonial => <TestimonialCard key={testimonial.name} testimonial={testimonial} data-id="element-233" data-mp="3sh8dw04cq1h3" />)}
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  testimonial,
  featured = false
}: {
  testimonial: Testimonial;
  featured?: boolean;
}) {
  const initials = testimonial.name.split(' ').map(part => part[0]).join('');
  return <figure className={['flex h-full flex-col items-center rounded-2xl border p-4 text-center sm:rounded-3xl sm:p-5', featured ? 'border-forest/20 bg-ivory shadow-card' : 'border-sandDark bg-ivory/70'].join(' ')} data-id="element-234" data-mp="ddq1ujbtpyxy">
      <div className="flex flex-col items-center gap-1.5" data-id="element-235" data-mp="3ls8hp780ais4">
        <span className="flex items-center gap-0.5" aria-label="Rated 5 out of 5" data-id="element-236" data-mp="3lqnj96ikmfoz">
          {Array.from({
          length: 5
        }).map((_, index) => <StarIcon key={index} className="h-3 w-3 fill-gold text-gold" aria-hidden="true" data-id="element-237" data-mp="3vitc0ignd158" data-mpi={index} />)}
        </span>
        <span className="text-[0.55rem] font-semibold uppercase tracking-label text-clay" data-id="element-238" data-mp="2y2e76wb5t6b1">
          {testimonial.highlight}
        </span>
      </div>

      <blockquote className={`mt-3 leading-relaxed text-ink ${featured ? 'font-serif text-[1.05rem] sm:text-xl' : 'text-[0.88rem]'}`} data-id="element-239" data-mp="1k75p6pi2cdsw">
        “{testimonial.quote}”
      </blockquote>

      <figcaption className="mt-auto flex items-center justify-center gap-2.5 pt-4 text-left" data-id="element-240" data-mp="1b5y3d6wqh5fp">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest font-serif text-[0.62rem] font-semibold uppercase text-ivory" data-id="element-241" data-mp="167wdo34sy7v9">
          {initials}
        </span>
        <span className="min-w-0" data-id="element-242" data-mp="wh1puubwr07p">
          <span className="block text-[0.8rem] font-semibold text-ink" data-id="element-243" data-mp="wg0cukbc03nc">{testimonial.name}</span>
          <span className="block text-[0.68rem] leading-snug text-muted" data-id="element-244" data-mp="sgrl1kzuqfuf">
            {testimonial.role} · {testimonial.location}
          </span>
        </span>
      </figcaption>
    </figure>;
}